import { api } from './http';

export type NavChild = { label: string; href: string; pill: string };
export type NavItem = { label: string; href: string; children: NavChild[] };
export type TickerRow = { label: string; value: string; change: string; dir: 'up' | 'down' };
export type Header = {
  ticker_on: boolean; ticker: TickerRow[]; nav: NavItem[];
  cta_login: string; cta_join: string;
};
export type FooterLink = { label: string; href: string };
export type Footer = {
  community?: { indian: string; forex: string };
  open_account?: { indian: string; forex: string };
  community_indian?: string;
  community_forex?: string;
  open_account_indian?: string;
  open_account_forex?: string;
  social: FooterLink[];
  columns: { heading: string; links: FooterLink[] }[];
};

export type ChromeResponse = {
  header: Header;
  footer: Footer;
  defaults: { header: Header; footer: Footer };
  /** Whether this part has been saved, or is still the design's own. */
  custom: { header: boolean; footer: boolean };
  logo_path: string;
  logo_default: string;
  site_url: string;
};

export const chrome = {
  load: (signal?: AbortSignal) => api.get<ChromeResponse>('/chrome', signal),
  save: (part: 'header' | 'footer', body: unknown) =>
    api.put<{ custom: boolean; logo_path: string }>(`/chrome/${part}`, body),
  /** Back to the design's own header or footer. */
  reset: (part: 'header' | 'footer') => api.del<{ custom: boolean }>(`/chrome/${part}`),
};
